// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Video from "@steiner/App/Components/Media/Video";
import YoutubeVideo from "@steiner/App/Components/Media/YoutubeVideo";
import * as React from "react";

export interface VideoProps {
    src: string;
    autoPlay?: boolean;
    controls?: boolean;
    extension?: string;
    isYoutubeVideo?: boolean;
    insideModal?: boolean;
}

type Props = VideoProps;

const VideoContainer: React.FC<Props> = ({ src, autoPlay, controls, extension, isYoutubeVideo, insideModal }) => {
    if (!src) {
        return null;
    }

    return (
        <>
            {isYoutubeVideo ? (
                <YoutubeVideo src={src} {...{ insideModal }} />
            ) : (
                <Video src={src} autoPlay={autoPlay} controls={controls} extension={extension} />
            )}
        </>
    );
};

export default VideoContainer;
